import { CollectionPreferences } from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";

export interface ContentOption {
  id: string;
  label: string;
  editable?: boolean;
}

interface PreferenceProps {
  preferences: { pageSize: number; visibleContent: string[] };
  options?: ContentOption[];
  handleOnConfirm: Function;
}

const Preference = ({
  preferences,
  options,
  handleOnConfirm,
}: PreferenceProps): JSX.Element => {
  return (
    <CollectionPreferences
      title={LABELS.PREFERENCE.TITLE}
      confirmLabel={LABELS.BTNS.CONFIRM}
      cancelLabel={LABELS.BTNS.CANCEL}
      preferences={preferences}
      pageSizePreference={{
        title: LABELS.PREFERENCE.SIZE_TITLE,
        options: [
          { value: 10, label: "10" },
          { value: 50, label: "50" },
          { value: 100, label: "100" },
        ],
      }}
      // visibleContentPreference={{
      //   title: LABELS.PREFERENCE.CONTENT_TITLE,
      //   options: [
      //     {
      //       label: "",
      //       options: options,
      //     },
      //   ],
      // }}
      onConfirm={({ detail }) => handleOnConfirm(detail)}
    />
  );
};

export default Preference;
